import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'invoice';

export const invoiceActions = createTypes([
    'save',
    'remove',
    'addItem',
    'removeItem',
    'setDiscount',
    'removeDiscount'
], namespace);

export const invoiceActionsCreators = {
    save: fromType(invoiceActions.save, ['invoice']),
    remove: fromType(invoiceActions.remove, ['id']),
    addItem: fromType(invoiceActions.addItem, ['id', 'item']),
    removeItem: fromType(invoiceActions.removeItem, ['id', 'itemId']),
    setDiscount: fromType(invoiceActions.setDiscount, ['id', 'discount']),
    removeDiscount: fromType(invoiceActions.removeDiscount, ['id']),
}